'use strict';

module.exports = function () {
    if (window.CI360) {
        window.CI360.initAll();
    }
};